export default __webpack_public_path__ + "static/media/016-koala.afc308a3.svg";